module.exports = __webpack_public_path__ + "img/done change password.da3637b1.png";